import { Actor, CollisionType } from "excalibur";

import { Resources } from "../Resources";

export default class Bottler extends Actor {
  constructor(setCollision) {
    super({
      x: 20 * 16,
      y: 9 * 16,
      radius: 5,
      collisionType: CollisionType.Fixed,
      name: "bottlerContainer",
      z: 5,
    });
    this.indicationShowing = false;
    this.bottlerCollider = new Actor({
      width: 10,
      height: 12,
      collisionType: CollisionType.Passive,
      name: "bottlerCollider",
    });
    let img = Resources.Bottler;
    let sprite = img.toSprite();
    this.graphics.add("bottler", sprite);

    this.addChild(this.bottlerCollider);
    this.bottlerCollider.on("collisionstart", (e) => {
      if (!this.indicationShowing && e.other.owner.name === "player") {
        console.log("collided with bottler");
        setCollision.setCollision(true, "bottler");
        this.createNotification();
      }
    });
    this.bottlerCollider.on("collisionend", () => {
      if (this.indicationShowing) {
        setCollision.setCollision(false, "bottler");
        this.destroyNotification();
      }
    });
  }
  createNotification() {
    this.indicationShowing = true;
    this.noti = document.getElementById("hive-indication");
    this.noti.style.bottom = 0;
    this.noti.style.height = "60px";
    this.noti.style.padding = "10px";

    this.noti.style.display = "block";
    this.noti.innerHTML = `<p id="notification">Space: Bottle Honey</p>`;
  }
  destroyNotification() {
    this.indicationShowing = false;
    this.noti.innerHTML = ``;
    this.noti.style.bottom = "-400px";
    this.noti.style.display = "none";
  }
  onInitialize() {
    this.graphics.use("bottler");
  }
  onPostUpdate() {}
}
